import { Outlet, createFileRoute, getRouteApi } from "@tanstack/react-router";

import { NavBar } from "@/components/client-navigation-bar";
import { fetchNavPages } from "@/lib/page-data";

const routeApi = getRouteApi("/view");

const ViewLayout = () => {
  const { pages } = routeApi.useLoaderData();

  return (
    <div className="min-h-[100dvh]">
      <NavBar pages={pages} />

      <div className="mx-auto w-full max-w-7xl px-6 py-10 lg:px-10">
        <Outlet />
      </div>
    </div>
  );
};

export const Route = createFileRoute("/view")({
  component: ViewLayout,
  loader: async () => ({ pages: await fetchNavPages() }),
});
